import { C_Container, coursesVariants } from "./Courses.styled";
import { observer } from "mobx-react";
import { useStores } from "../../../../../../stores";
import { CourseItem } from "./CourseItem/CourseItem";
import { useParams } from "react-router-dom";

interface CoursesProps {}

export const Courses = observer(({}: CoursesProps) => {
	const { grandCharts } = useStores();
	const { selected } = grandCharts;

	const { courseId } = useParams<{
		courseId: string;
	}>();

	const activeCourseId = Number(courseId);

	return (
		<C_Container variants={coursesVariants}>
			{selected.grand_chart_courses.map((grandChartCourse, index) => {
				return (
					<CourseItem
						key={grandChartCourse.id}
						index={index}
						service={selected.service.slug}
						grandChartCourse={grandChartCourse}
						isActive={activeCourseId === grandChartCourse.id}
					/>
				);
			})}
		</C_Container>
	);
});
